module.exports = __webpack_public_path__ + "img/Group 2575.51360b23.png";